module.exports = __webpack_public_path__ + "static/media/Lateral_Moderate_Z2.80cc12b2.png";